module.exports = __webpack_public_path__ + "img/reset.b7bd0280.png";